export default {
    "name": "PartSearchData",
    "kind": "HoudiniQuery",
    "hash": "050b0f370730d1a73b0202849020584c53615028da7f976bb25fa86a58fd9e2e",

    "raw": `query PartSearchData($userAccountId: Int!, $filter: InventoryFieldsFilter!) {
  userAccount(id: $userAccountId) {
    inventorySearchableStores {
      id
      name
      code
    }
    id
  }
  session {
    userAccount {
      searchModules {
        default
        module {
          id
          name
        }
      }
      settings {
        searchParts {
          pinnedSearchFields
        }
      }
      id
    }
    id
  }
  inventoryFields(filter: $filter) {
    id
    displayName
    fieldType
    fieldOptions
    searchByRange
    searchMode
    fieldName
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "userAccount": {
                "type": "UserAccount",
                "keyRaw": "userAccount(id: $userAccountId)",

                "selection": {
                    "fields": {
                        "inventorySearchableStores": {
                            "type": "Store",
                            "keyRaw": "inventorySearchableStores",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "code": {
                                        "type": "String",
                                        "keyRaw": "code",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "session": {
                "type": "Session",
                "keyRaw": "session",

                "selection": {
                    "fields": {
                        "userAccount": {
                            "type": "UserAccount",
                            "keyRaw": "userAccount",

                            "selection": {
                                "fields": {
                                    "searchModules": {
                                        "type": "UserSearchModel",
                                        "keyRaw": "searchModules",

                                        "selection": {
                                            "fields": {
                                                "default": {
                                                    "type": "Boolean",
                                                    "keyRaw": "default",
                                                    "visible": true
                                                },

                                                "module": {
                                                    "type": "SearchModule",
                                                    "keyRaw": "module",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "Int",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "settings": {
                                        "type": "UserSettings",
                                        "keyRaw": "settings",

                                        "selection": {
                                            "fields": {
                                                "searchParts": {
                                                    "type": "UserSettingsSearchPartsCategory",
                                                    "keyRaw": "searchParts",

                                                    "selection": {
                                                        "fields": {
                                                            "pinnedSearchFields": {
                                                                "type": "String",
                                                                "keyRaw": "pinnedSearchFields",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "inventoryFields": {
                "type": "InventoryField",
                "keyRaw": "inventoryFields(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "displayName": {
                            "type": "String",
                            "keyRaw": "displayName",
                            "visible": true
                        },

                        "fieldType": {
                            "type": "InventoryFieldTypeEnum",
                            "keyRaw": "fieldType",
                            "visible": true
                        },

                        "fieldOptions": {
                            "type": "String",
                            "keyRaw": "fieldOptions",
                            "visible": true
                        },

                        "searchByRange": {
                            "type": "Boolean",
                            "keyRaw": "searchByRange",
                            "visible": true
                        },

                        "searchMode": {
                            "type": "InventoryFieldSearchModeEnum",
                            "keyRaw": "searchMode",
                            "visible": true
                        },

                        "fieldName": {
                            "type": "String",
                            "keyRaw": "fieldName",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "userAccountId": "Int",
            "filter": "InventoryFieldsFilter"
        },

        "types": {
            "InventoryFieldsFilter": {
                "global": "Boolean",
                "searchable": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=81e37bdbd04e2afe3518745dfa9f46c10afdbfc89ac4b2720d27545820bf8067";